var _circle, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F601(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.526 27.916c-1.859-5.112-4.66-7.669-7.461-7.669s-5.602 2.558-7.46 7.669c-.184.515.774 1.442 1.254.938 1.802-1.902 3.957-2.659 6.206-2.659 2.25 0 4.405.757 6.207 2.659.479.504 1.438-.423 1.254-.938zM50.396 27.916c-1.859-5.112-4.66-7.669-7.461-7.669s-5.602 2.558-7.461 7.669c-.184.515.775 1.442 1.254.938 1.803-1.902 3.957-2.659 6.207-2.659s4.404.757 6.207 2.659c.478.504 1.437-.423 1.254-.938z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M54 37.41c0-.803-.614-1.809-2.358-2.066C47.159 34.682 40.535 34 31.999 34h-.001c-8.535 0-15.159.682-19.641 1.344C10.611 35.602 10 36.607 10 37.41 10 47 13.492 50 27.81 50h8.381C50.508 50 54 47 54 37.41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M48.934 38.169c.193-.507-.054-.982-.549-1.058 0 0-7.393-1.111-16.385-1.111-8.993 0-16.385 1.111-16.385 1.111-.496.075-.743.551-.549 1.058l1.115 2.909c.194.507.762.922 1.262.922h29.114c.501 0 1.069-.415 1.263-.922l1.114-2.909zM32 48c6.376 0 15.467 0 15.223-2.053a7.987 7.987 0 0 0-.289-1.276c-.155-.526-.28-.671-1.377-.671H18.444c-1.099 0-1.221.145-1.378.671-.137.474-.245.909-.289 1.276C16.533 48 25.624 48 32 48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F601);
export default __webpack_public_path__ + "static/media/1f601.00d26e1f1224c55553ed045426d2613f.svg";
export { ForwardRef as ReactComponent };